import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  fetchMealPullList,
  fetchMealPullListSuccess,
  fetchMealPullListFailure,
  downloadMealPullListPdfSuccess,
  downloadMealPullListPdfFailure,
} from "./actions";
import {
  FETCH_MEAL_PULL_LIST,
  ACKNOWLEDGE_MEAL_PROFILE,
  DOWNLOAD_MEAL_PULL_LIST_PDF,
} from "./constants";

export function* fetchMealPullListSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, service } = payload || {};
  const query = service && service !== "all" ? `?service=${service}` : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${id}/meal-pull-list${query}`,
    );
    // apiResponse wraps the body as { status, data: {...}, message }.
    const body = data?.data ?? data ?? {};
    yield put(
      fetchMealPullListSuccess({
        residents: body.residents ?? [],
        generatedAt: body.generated_at ?? null,
        location: body.location ?? null,
        insights: body.insights ?? null,
        prepSummary: body.prep_summary ?? null,
      }),
    );
  } catch (e) {
    yield put(fetchMealPullListFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while loading the kitchen pull list."));
  }
}

export function* downloadMealPullListPdfSaga({ payload, onDone }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, locationName, service } = payload || {};
  const query = service && service !== "all" ? `?service=${service}` : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/location/${id}/meal-pull-list/pdf${query}`,
    );
    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Kitchen-Pull-List-${locationName || id}.pdf`,
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    yield put(downloadMealPullListPdfSuccess());
    typeof onDone === "function" && onDone();
  } catch (e) {
    yield put(downloadMealPullListPdfFailure());
    yield put(errorAlert("Error while generating the PDF."));
  }
}

export function* acknowledgeMealProfileSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, residentId } = payload || {};
  try {
    yield call(
      api(token).post,
      `/api/location/${locationId}/meal-pull-list/acknowledge/${residentId}`,
    );
    // Refetch so the acknowledged card + the insights counts update.
    yield put(fetchMealPullList({ id: locationId }));
  } catch (e) {
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Could not acknowledge the meal update."));
  }
}

export function* fetchMealPullListFlow() {
  yield takeEvery(FETCH_MEAL_PULL_LIST, fetchMealPullListSaga);
}
export function* acknowledgeMealProfileFlow() {
  yield takeEvery(ACKNOWLEDGE_MEAL_PROFILE, acknowledgeMealProfileSaga);
}
export function* downloadMealPullListPdfFlow() {
  yield takeEvery(DOWNLOAD_MEAL_PULL_LIST_PDF, downloadMealPullListPdfSaga);
}

export default function* MealPullListSaga() {
  yield all([
    fetchMealPullListFlow(),
    acknowledgeMealProfileFlow(),
    downloadMealPullListPdfFlow(),
  ]);
}
